<div *ngIf="cargando" class="flex justify-center items-center min-h-screen">
    <div class="flex flex-col items-center">
      <div class="spinner-border animate-spin inline-block w-12 h-12 border-4 border-t-transparent border-azul rounded-full" role="status">
      </div>
      <p class="mt-4 text-lg text-azul">{{'cargando-productos' | translate}}</p>
    </div>
</div>
<div *ngIf="mostrarTienda && !cargando" class="p-5">
  <!-- Titulo Tienda -->
  <div class="flex justify-center items-center animate-fade">
    <h1 class="text-xl sm:text-2xl md:text-3xl font-extrabold text-azul text-center md:text-left">{{ 'tienda' | translate }}</h1>
  </div>

  <!-- Boton Filtros -->
  <div class="animate-fade-right">
    <button (click)="mostrarFiltros = !mostrarFiltros" class="bg-azul text-white p-2 cursor-pointer rounded-lg hover:text-blue-300 duration-1000">
      {{ mostrarFiltros ? ('ocultar-filtros' | translate) : ('mostrar-filtros' | translate) }}
    </button>
  </div>

  <!-- Contenedor Filtros -->
  <div class="overflow-hidden transition-max-height duration-500 ease-in-out grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 m-6" [ngClass]="{ 'max-h-0': !mostrarFiltros, 'max-h-screen': mostrarFiltros }">
    <!-- Filtro Tipo de Producto -->
    <div>
      <label class="block mb-1 text-azul">{{'filtro-producto' | translate}}</label>
      <select id="tipoProducto" class="border border-blue-700 text-azul rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500" [(ngModel)]="filtroTipoProducto" (change)="aplicarFiltros()">
        <option value="">{{ 'todos-productos' | translate }}</option>
        <option value="ropa">{{ 'ropa' | translate }}</option>
        <option value="merchandising">{{ 'merchandising' | translate }}</option>
      </select>
    </div>
    
    <!-- Filtro Equipo -->
    <div>
      <label class="block mb-1 text-azul">{{'filtro-equipo' | translate}}</label>
      <select class="border border-blue-700 text-azul rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500" [(ngModel)]="filtroEquipo" (change)="aplicarFiltros()">
        <option value="">{{ 'todos_los_equipos' | translate }}</option>
        <option *ngFor="let equipo of equipos" [value]="equipo.ID">{{ equipo.nombre }}</option>
      </select>
    </div>

    <!-- Filtro Rango de Precio -->
    <div>
      <label class="block mb-1 text-azul">{{'filtro-precio' | translate}}</label>
      <div class="flex flex-col gap-2">
        <input type="number" min="0" class="border border-blue-700 text-azul rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="{{ 'precio-minimo' | translate }}" [(ngModel)]="filtroPrecioMin" (change)="aplicarFiltros()">
        <input type="number" min="0" class="border border-blue-700 text-azul rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="{{ 'precio-maximo' | translate }}" [(ngModel)]="filtroPrecioMax" (change)="aplicarFiltros()">
      </div>
    </div>
    
    <!-- Ordenador Precio -->
    <div>
      <label class="block mb-1 text-azul">{{'metodo-ordenacion' | translate}}</label>
      <select class="border border-blue-700 text-azul rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500" [(ngModel)]="ordenPrecio" (change)="aplicarFiltros()">
        <option value="">{{ 'metodo-ordenacion' | translate }}</option>
        <option value="asc">{{ 'precio-asc' | translate }}</option>
        <option value="desc">{{ 'precio-desc' | translate }}</option>
      </select>
    </div>
  </div>

  <!-- Contenedor Tienda -->
  <div class="animate-fade-up">
    <!-- Contenedor Productos -->
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 p-5 mt-3">
      <div *ngFor="let producto of productosPaginados" class="group rounded-2xl p-3 grid grid-rows-[1fr,auto,auto] gap-2 h-full border-t shadow-lg cursor-pointer shadow-gray-500"
        (click)="producto.stock > 0 && comprarProducto(producto.ID)"
        [class.cursor-not-allowed]="producto.stock <= 0"
        [class.opacity-50]="producto.stock <= 0"> 
        <img class="transition-transform duration-1000 ease-in-out group-hover:scale-75 rounded w-full h-auto object-contain" src="{{ producto.imagen }}" alt="Imagen del producto">
        <h1 class="group-hover:underline text-lg font-semibold tracking-tight text-azul">{{ producto.nombre }}</h1>
        <div *ngIf="producto.stock <= 0" class="p-2">
          <p class="text-left text-md font-medium">{{'sin-stock' | translate}}</p>
        </div>
        <div *ngIf="producto.stock > 0">
          <p class="inline-block text-left text-md font-medium bg-azul rounded-md p-1 text-white">{{'precio' | translate}} {{ producto.precio }}€</p>
        </div>
      </div>
    </div>

    <!-- Paginador -->
    <div class="flex justify-center items-center gap-2 mt-4">
      <button class="text-azul" (click)="cambiarPagina(1)" [disabled]="paginaActual == 1">
        <mat-icon fontIcon="keyboard_double_arrow_left"></mat-icon>
      </button>
      <button class="text-azul" (click)="cambiarPagina(paginaActual - 1)" [disabled]="paginaActual == 1">
        <mat-icon fontIcon="arrow_back_iost"></mat-icon>
      </button>
    
      <span class="text-azul">{{'pagina' | translate}} {{ paginaActual }} {{'de' | translate}} {{ totalPaginas }}</span>

      <button class="text-azul" (click)="cambiarPagina(paginaActual + 1)" [disabled]="paginaActual == totalPaginas">
        <mat-icon fontIcon="arrow_forward_iost"></mat-icon>
      </button>
      <button class="text-azul" (click)="cambiarPagina(totalPaginas)" [disabled]="paginaActual == totalPaginas">
        <mat-icon fontIcon="keyboard_double_arrow_right"></mat-icon>
      </button>
    </div>
  </div>
</div>
